module.exports = __webpack_public_path__ + "static/img/szafa_dso_50.06718f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_dso_50.svg
// module id = 71AO
// module chunks = 1